import { app } from "../app";
import SvgIcon from "@/components/SvgIcon.vue";
// @ts-ignore
app.component("SvgIcon", SvgIcon);
